import InscreenObserver from '@finn-no/inscreen-observer';
import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', 'bucketcookieservice'],
    callable(element, bucketCookie) {
        const firstSeen = bucketCookie.get('firstCalloutSeen');
        const popularSeen = bucketCookie.get('popularCalloutSeen');
        const type = element.getAttribute('data-callout-type');

        if (!document.getElementById('result-item-callout')) {
            if (type === 'first' && !firstSeen) {
                createCallout('Ingen har sendt melding. Førstemann til mølla!');
            } else if (type === 'popular' && !popularSeen) {
                createCallout('Mange har sendt melding. Her blir det kamp!');
            }
        }

        function createCallout(text) {
            const calloutMargin =
                element.getAttribute('data-view-type') === 'list'
                    ? 'margin-left: 0px !important;'
                    : '';

            const callout = el(
                'div.context-box.bg-mint.up.mal.bordered.border-pea.pam',
                {
                    id: 'result-item-callout',
                    style: calloutMargin,
                },
                el(
                    'div.inlineblockify',
                    null,
                    el(
                        'style',
                        null,
                        `.context-box.up:before {
                            left: 16%;
                        }`
                    ),
                    el(
                        'button.blank.callout-close-button.mls',
                        {
                            onclick: event => {
                                callout.remove();
                                setCookie();
                                event.preventDefault();
                            },

                            style:
                                'float:right;cursor:pointer;border:2px solid #CCFFEC;padding: 1px;',
                        },
                        el(
                            'style',
                            null,
                            `.callout-close-button:hover {
                            border: 2px solid #28CD94 !important;
                        }`
                        ),
                        el(
                            'svg:svg.valign-middle.blockify',
                            {
                                width: '12',
                                height: '12',
                                viewBox: '0 0 18 18',
                            },
                            el('svg:path', {
                                stroke: '#28CD94',
                                'stroke-width': '2',
                                d: 'M2 2l14 14M16 2L2 16',
                            })
                        )
                    ),
                    el('p', { style: 'margin: 0px; line-height: 18px;' }, text)
                )
            );
            element.append(callout);

            const calloutObserver = new InscreenObserver(setCookie, {
                threshold: 0.7,
                timeout: 3000,
                once: true,
            });

            calloutObserver.observe(element);
        }

        function setCookie() {
            if (type === 'first') {
                bucketCookie.set('firstCalloutSeen', true);
            } else {
                bucketCookie.set('popularCalloutSeen', true);
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/resultItemCallout.js